import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import PrizesListPage from "@/app/(custom-header)/prizes/[prizeName]/page";

const root = createRoot(document.getElementById("subscription-prizes-details-page") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <PrizesListPage />
    </StoreProvider>
  </React.StrictMode>
);
